import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const PrivateAdminRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get("/api/is-admin", {
          headers: { Authorization: `Bearer ${token}` }
        });

        setIsAdmin(response.data.is_admin);
      } catch (err) {
        console.error("Error checking admin status", err);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdmin();
  }, []);

  if (isLoading) return <LoadingSpinner />

  if (!isAdmin) return <Navigate to="/" />;

  return children;
};

export default PrivateAdminRoute;
